<template>
  <div class='properties-search'>
    <div class='default-content'>
      <h1 class='section-title'>{{locales.properties && locales.properties.all_properties}}</h1>
      <div class='properties-control'>
        <div class='properties-control__left'>
          <div class='properties-control__terms'>
            <a class='properties-control__terms-item properties-control__terms-item--active' :href='buttonUrl'>{{locales.searches && locales.searches.click_here_for_rental_form}}</a>
          </div>
        </div>
        <div class='properties-control__right'>
          <a class='properties-control__switcher' :class="{ 'properties-control__switcher--active': isGrid }" @click.prevent='isGrid ? null : setLayout("grid")'>
            <i class='icon-grid'/>
          </a>
          <a class='properties-control__switcher' :class="{ 'properties-control__switcher--active': isMap }" @click.prevent='isMap ? null : setLayout("map")'>
            <i class='icon-map'/>
          </a>
          <div class='theme-order-select ml-auto pl-2.5'>
            <select class='theme-order-select__item' name='order' @change='sort'>
              <option value='created_desc' :selected="order === 'created_desc'">
                {{ locales && locales.filters && locales.filters.newest_oldest }}
              </option>
              <option value='created_asc' :selected="order === 'created_asc'">
                {{ locales && locales.filters && locales.filters.oldest_first }}
              </option>
              <option value='location_asc' :selected="order === 'location_asc'">
                {{ locales && locales.filters && locales.filters.location_a_z }}
              </option>
              <option value='location_desc' :selected="order === 'location_desc'">
                {{ locales && locales.filters && locales.filters.location_z_a }}
              </option>
              <option value='people_asc' :selected="order === 'people_asc'">
                {{ locales && locales.filters && locales.filters.people_low_to_high }}
              </option>
              <option value='people_desc' :selected="order === 'people_desc'">
                {{ locales && locales.filters && locales.filters.people_high_to_low }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import queryString from 'query-string';
  import {mapGetters} from 'vuex';
  import VAutocompletePublic from './../admin/components/VAutocompletePublic';
  

  export default {
    components: {
      VAutocompletePublic,
    },
    props: {
      websiteId: {
        default: '',
        type: String,
      },
      buttonUrl: {
        default: '',
        type: String,
      },
      filteringOptions: {
        default: () => {},
        type: Object,
      },
    },
    data() {
      return {
        order: queryString.parse(window.location.search).order,
      };
    },
    created() {
    },
    computed: {
      ...mapGetters(['metadata', 'locales']),
      layout() {
        return this.$store.getters.getSearchprofilesLayout;
      },
      website: function() {
        if (this.websiteId == 1) {
          return 'athome';
        } else {
          return 'staffhousing';
        }
      },
      isGrid: function() {
        return this.$store.getters.getSearchprofilesIsGrid;
      },
      isMap: function() {
        return this.$store.getters.getSearchprofilesIsMap;
      },
      term: function() {
        return this.$store.getters.getSearchprofilesTerm;
      },
    },
    methods: {
      setLayout(layout) {
        this.$store.commit('SET_SEARCHPROFILES_LAYOUT', layout);
      },
      changeDistance(event) {
        let search = queryString.parse(window.location.search);
        search.ray = event.target.value;
        window.location.search = queryString.stringify(search);
      },
      sort(event) {
        let search = queryString.parse(window.location.search);
        search.order = event.target.value;
        window.location.search = queryString.stringify(search);
      }
    },
  };
</script>
